import { render } from "./FilterNewFlat.vue?vue&type=template&id=2e0a623f"
import script from "./FilterNewFlat.vue?vue&type=script&lang=js"
export * from "./FilterNewFlat.vue?vue&type=script&lang=js"

import "./FilterNewFlat.vue?vue&type=style&index=0&id=2e0a623f&lang=scss"

import exportComponent from "/home/www-kvs/public_html/resources/frontend/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__